import { v1 } from '@/api/client';
import { NotificationToken } from './api.types';

export const addRegistrationToken = (request: NotificationToken) =>
  v1.post('registration/token', request);

export const removeRegistrationToken = (request: NotificationToken) =>
  v1.remove('registration/token', request);
